module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"total":"Total","classTitle":"Eignungsklasse","shareTitle":"Anteil","roofAreaTitle":"Dachfläche","fassadeAreaTitle":"Fassadenfläche","irradiationTitle":"Einstrahlung"}}')
  delete Component.options._Ctor
}
